import { motion } from "framer-motion";
import { Star } from "lucide-react";
import { Reveal } from "./Reveal";

const reviews = [
  {
    quote: "The Rose Marry jar has become my evening ritual — the glow through the perforations is genuinely calming.",
    name: "Ananya R.",
    city: "Bengaluru",
  },
  {
    quote: "Ordered the Diwali gift set for my parents. Beautifully wrapped, and the sandalwood filled the whole room.",
    name: "Rohit M.",
    city: "Mysuru",
  },
  {
    quote: "No headaches, no sooty smell — just clean lavender warmth. You can tell these are hand-poured with care.",
    name: "Priya S.",
    city: "Chennai",
  },
];

export const Reviews = () => (
  <section id="reviews" className="py-20 md:py-28">
    <div className="max-w-6xl mx-auto px-4 sm:px-6">
      <Reveal className="text-center max-w-2xl mx-auto mb-14">
        <span className="text-xs uppercase tracking-[0.25em] font-semibold text-brandTerracotta">Kind Words</span>
        <h2 className="font-serif text-3xl sm:text-4xl font-bold mt-3">Loved by calm seekers</h2>
        <p className="text-brandDarkSlate/75 mt-3 text-sm sm:text-base">
          Early love from our first candle families across India.
        </p>
      </Reveal>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {reviews.map((r, i) => (
          <Reveal key={r.name} delay={i * 0.12} className="h-full">
            <motion.blockquote
              data-testid={`review-card-${i + 1}`}
              whileHover={{ y: -6 }}
              transition={{ type: "spring", stiffness: 250, damping: 20 }}
              className="h-full bg-white p-8 rounded-2xl border border-brandSand shadow-sm hover:shadow-xl hover:shadow-brandTerracotta/10 transition-shadow flex flex-col gap-4"
            >
              <div className="flex gap-1 text-brandAmber" aria-label="5 out of 5 stars">
                {Array.from({ length: 5 }).map((_, s) => (
                  <Star key={s} className="w-4 h-4 fill-current" />
                ))}
              </div>
              <p className="font-serif italic text-lg leading-relaxed flex-1">&ldquo;{r.quote}&rdquo;</p>
              <footer className="text-xs tracking-wide">
                <span className="font-bold">{r.name}</span>
                <span className="text-brandDarkSlate/60"> · {r.city}</span>
              </footer>
            </motion.blockquote>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
